export enum ThemeNames {
  default = 'default',
  voltex = 'voltex',
  rio = 'rio',
}
